import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GlobalShortcuts = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const isMod = e.ctrlKey || e.metaKey;

            // اگه Ctrl یا Cmd نگه داشته نشده، کاری نکن
            if (!isMod) return;

            const key = e.key.toLowerCase();

            // ==========================================
            // Ctrl + Shift + N → ایجاد بازاریاب جدید
            // ==========================================
            if (e.shiftKey && key === "a") {
                e.preventDefault();
                e.stopPropagation();
                navigate("/admin/marketers/add");
                return;
            }

            // ==========================================
            // Ctrl + Shift + M → لیست بازاریاب‌ها
            // ==========================================
            if (e.shiftKey && key === "m") {
                e.preventDefault();
                e.stopPropagation();
                navigate("/admin/marketers");
                return;
            }

            // ==========================================
            // Ctrl + Shift + D → داشبورد
            // ==========================================
            if (e.shiftKey && key === "d") {
                e.preventDefault();
                e.stopPropagation();
                navigate("/admin/dashboard");
                return;
            }

            // ==========================================
            // هر شورت‌کات دیگه‌ای که خواستی اینجا اضافه کن
            // ==========================================
        };

        window.addEventListener("keydown", handleKeyDown, { capture: true });
        return () => {
            window.removeEventListener("keydown", handleKeyDown, {
                capture: true,
            });
        };
    }, [navigate]);

    return null;
};

export default GlobalShortcuts;